import React, { useState, useEffect } from 'react';
import { Container, Typography, Paper, Box, TextField, Button, Snackbar, Alert, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import Seo from '../components/common/Seo';

function Contact() {
    const { currentUser } = useAuth();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [open, setOpen] = useState(false);
    const [error, setError] = useState('');
    const [openDialog, setOpenDialog] = useState(false);
    const [pendingSubmission, setPendingSubmission] = useState(null);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            console.log('currentUser:', currentUser);

            const contactData = {
                ...formData,
                ...(currentUser && { userId: currentUser.uid })
            };

            await axios.post('/api/contact', contactData);
            setOpen(true);
            setFormData({ name: '', email: '', subject: '', message: '' });
        } catch (error) {
            console.error('Error:', error);
            setError(error.response?.data?.error || 'エラーが発生しました。もう一度お試しください。');
        }
    };

    const handleSubmitClick = (e) => {
        e.preventDefault();
        setOpenDialog(true);
        setPendingSubmission(e);
    };

    const handleConfirmSubmit = async () => {
        try {
            await handleSubmit(pendingSubmission);
            setOpenDialog(false);
        } catch (error) {
            console.error('Error:', error);
            setError(error.response?.data?.error || 'エラーが発生しました。もう一度お試しください。');
            setOpenDialog(false);
        }
    };

    useEffect(() => {
        if (currentUser) {
            setFormData(prev => ({
                ...prev,
                name: currentUser.name || '',
                email: currentUser.email || ''
            }));
        }
    }, [currentUser]);

    return (
        <>
            <Seo
                title="お問い合わせ"
                description="Room Share Matchingへのお問い合わせページです。サービスに関するご質問、ご意見、お問い合わせはこちらからお願いします。"
                path="/contact"
                keywords="お問い合わせ,問い合わせフォーム,ルームシェア,サポート,Room Share Matching"
            />
            <Container maxWidth="md">
                <Paper sx={{ p: 4, mt: 4 }}>
                    <Typography variant="h4" component="h1" gutterBottom>
                        お問い合わせ
                    </Typography>
                    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
                        <TextField
                            fullWidth
                            label="お名前"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            margin="normal"
                            required
                        />
                        <TextField
                            fullWidth
                            label="メールアドレス"
                            name="email"
                            type="email"
                            value={formData.email}
                            onChange={handleChange}
                            margin="normal"
                            required
                        />
                        <TextField
                            fullWidth
                            label="件名"
                            name="subject"
                            value={formData.subject}
                            onChange={handleChange}
                            margin="normal"
                            required
                        />
                        <TextField
                            fullWidth
                            label="お問い合わせ内容"
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            multiline
                            rows={4}
                            margin="normal"
                            required
                        />
                        <Button
                            type="submit"
                            variant="contained"
                            sx={{ mt: 3 }}
                            onClick={handleSubmitClick}
                        >
                            送信
                        </Button>
                    </Box>
                </Paper>

                <Dialog
                    open={openDialog}
                    onClose={() => setOpenDialog(false)}
                >
                    <DialogTitle>確認</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            お問い合わせを送信しますか？
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenDialog(false)}>
                            キャンセル
                        </Button>
                        <Button onClick={handleConfirmSubmit} variant="contained">
                            送信する
                        </Button>
                    </DialogActions>
                </Dialog>

                <Snackbar open={open} autoHideDuration={6000} onClose={() => setOpen(false)}>
                    <Alert severity="success">お問い合わせを送信しました</Alert>
                </Snackbar>
                {error && (
                    <Snackbar open={!!error} autoHideDuration={6000} onClose={() => setError('')}>
                        <Alert severity="error">{error}</Alert>
                    </Snackbar>
                )}
            </Container>
        </>
    );
}

export default Contact;